export default __webpack_public_path__ + "static/media/img-slider-banpu-power-2.8265b6c1.png";